import $ from 'jquery';
import 'jquery-ui/ui/disable-selection';
import 'jquery-ui/ui/widgets/sortable';
import Cookies from 'js-cookie';

/*
 * TODO: add [x]-Button to search-fields
 */

/* Module utilities
 * ---------------------------------------------------------------- */

$.xiModuleId = function (obj) {
  if (typeof obj == 'string') {
    return parseInt(obj.replace(/[^@]+@/, ''), 10);
  } else if ('module' in obj) {
    return $.xiModuleId(obj.module);
  } else {
    return '';
  }
};

$.fn.xiTable = function (options) {
  const o = $.extend($.fn.xiTable.defaults, options);

  /* (Re)load data
   * ---------------------------------------------------------------- */

  const _update = function (table, state, data) {
    if (!Array.isArray(data.rows)) {
      data.rows = [];
    }

    let cols = o.columns;
    let rows = data.rows;
    let i = 0;
    let il = rows.length;
    let b = ['<tbody>'];
    let cl = 0;
    let ci = 0;
    let c = 0;

    if ('categories' in data) {
      let cats = [];
      cl = data.categories.length;
      while (ci < cl) {
        c = data.categories[ci];
        cats = cats.concat([
          '<li><a href="#category-',
          c._id,
          '">',
          c[o.categoryTitleColumn],
          '</a></li>',
        ]);
        ci++;
      }
      table.find('div.categories ul').html(cats.join(''));
    }

    while (i < il) {
      let row = rows[i++];
      let j = 0;
      let jl = cols.length;
      b.push('<tr id="xisortorder_' + row._id + '">');

      // add rows
      while (j < jl) {
        var cd = cols[j++];
        b.push('<td');
        if (cd.style != null) {
          b.push(' style="' + cd['style'] + '"');
        }
        if (cd.class != null) {
          b.push(' class="' + cd['class'] + '"');
        }
        b.push('>');
        var d = cd.display;
        b.push(typeof d === 'function' ? d.bind(row)() : row[d]);
        b.push('</td>');
      }
      b.push('</tr>');
    }
    b.push('</tbody>');

    // TODO: animate
    table.find(o.tbody).replaceWith(b.join(''));

    const tbody = table.find(o.tbody);

    /* sorting
     * ---------------------------------------------------------------- */

    // FIXME: funktioniert nur, wenn ALLE Einträge sichtbar sind!
    if ('sortable' in o) {
      tbody
        .sortable({
          axis: 'y',
          containment: 'parent',
          // TODO: reset even/odd classes (?)
          update: function (_event, _ui) {
            $.post(
              o.queryUrl,
              [
                $.param($.extend({}, data, { action: 'change-order' })),
                '&',
                tbody.sortable('serialize'),
              ].join(''),
              function (data) {
                if (data == 'ok') {
                  $.notify(
                    'Reihenfolge',
                    'Die neue Reihenfolge wurde gespeichert.',
                  );
                  load(table, state);
                }
              },
              'json',
            );

            $.post(
              o.queryUrl,
              'action=change-order&' + tbody.sortable('serialize'),
              function (data, _textStatus) {
                if (data == 'ok') {
                  $.notify(
                    'Reihenfolge',
                    'Die neue Reihenfolge wurde gespeichert.',
                  );
                }
              },
            );
          },
        })
        .disableSelection();
    }

    /* categories
     * ---------------------------------------------------------------- */

    if ('categories' in data) {
      const cli = table.find('div.categories li');
      cli.find('a').click(function () {
        var self = $(this);
        var ms = self.attr('href').match(/\#category\-([a-z0-9-]+)$/);
        if (ms) {
          var ncat = ms[1]; //parseInt(ms[1], 10);
          self.closest('ul').find('li').removeClass('active loading');
          if (state.category != ncat) {
            self.closest('li').addClass('active loading');
            state.category = ms[1]; //parseInt(ms[1], 10);
          } else {
            state.category = null;
          }
        } else {
          state.category = null;
        }

        Cookies.set('table-category-' + location.pathname, state.category, {
          expires: new Date(Date.now() + 60 * 60 * 1000),
        });

        load(table, state);
        return false;
      });

      // deselect
      tbody
        .find('div.categories')
        .add(table.find('div.categories'))
        .click(function () {
          state.category = null;
          load(table, state);
          return false;
        });

      // highlight selected category
      if (state.category) {
        cli
          .find('a[href $= "#category-' + state.category + '"]')
          .closest('li')
          .addClass('active');
      }
    }

    $.extend(o.paginator, data.paginator);
    paginator(table, data.paginator);
  };

  const load = function (table, state) {
    let data = {};

    for (var k in state) {
      data[state.prefix + k] = state[k];
    }
    // TODO: show loading indicator inside table

    $.getJSON(o.queryUrl, data, function (data) {
      _update(table, state, data);
    });
  };

  /* Navigation
   * ---------------------------------------------------------------- */

  const _navigate = function (table, state, pos) {
    var page = state.page;
    switch (pos) {
      case 'left':
        page--;
        break;
      case 'right':
        page++;
        break;
      case 'first':
        page = 1;
        break;
      case 'last':
        page = state.pagesTotal;
        break;
      default:
        page = parseInt(pos, 10);
        break;
    }
    state.page = page;
    Cookies.set('table-page', page);

    load(table, state);
  };

  /* Setup / update paginator
   * ---------------------------------------------------------------- */

  const buildNav = function (current, total, max) {
    if (total > max) {
      var r = parseInt(max / 2, 10),
        c = parseInt(current, 10);
      if (c <= r) {
        return [1, max];
      } else if (c > total - r) {
        return [total - max, total];
      } else {
        return [c - r, c + r];
      }
    } else {
      return [1, total];
    }
  };

  const showNumberOfItemsSelector = (parent, itemCounts, table, state) => {
    const items = itemCounts
      .map(
        (count) =>
          `<li><a href="#" data-item-count="${count}">${count} Einträge</a></li>`,
      )
      .join('');

    const ul = $(`<ul class="paginator-count-popup">${items}</ul>`);

    ul.insertAfter(parent)
      .on('click', 'a', (event) => {
        event.stopPropagation();
        event.preventDefault();

        const count = parseInt(event.target.dataset.itemCount, 10);

        state.items = count;
        state.page = Math.max(
          1,
          parseInt((state.items * state.page) / count, 10),
        );
        load(table, state);

        ul.fadeOut(() => ul.remove());
      })
      .on('mouseleave', () => {
        ul.fadeOut(() => ul.remove());
      });
  };

  const paginator = function (table, state) {
    const el = table.find('.paginator');
    const sx = el.find('.scroll-x:first');

    const tpl = [
      '<li class="scroll-? xioni-scrolltpl">',
      sx.html(),
      '</li>',
    ].join('');

    const buttons = [];
    if (state.pagesTotal > 1) {
      var range = buildNav(state.page, state.pagesTotal, o.maxPages);
      for (var i = range[0]; i <= range[1]; i++) {
        buttons.push(tpl.replace(/\?/g, i));
      }
    }

    el.find('ul li.xioni-scrolltpl').remove();
    sx.hide().after(buttons.join(''));
    el.find('.paginator-count').text(state.total);
    el.find('.paginator-page').text(state.page);
    el.find('.paginator-pagecount').text(state.pagesTotal);

    const countButton = el.find('.paginator-button-items');

    countButton
      .text(state.items)
      .unbind('click.paginator')
      .bind('click.paginator', (event) => {
        event.stopPropagation();
        event.preventDefault();

        el.find('.paginator-count-popup').remove();
        showNumberOfItemsSelector(countButton, o.itemCounts, table, state);
      });
    el.find('ul .scroll-first:first, ul .scroll-left:first')[
      state.page > 1 ? 'fadeIn' : 'fadeOut'
    ]();

    el.find('ul .scroll-last:first, ul .scroll-right:first')[
      state.page < state.pagesTotal ? 'fadeIn' : 'fadeOut'
    ]();

    el.find('ul li[class*="scroll-' + state.page + '"]').addClass('active');
    el.find('ul li[class*="scroll-"] a.button')
      .unbind('click.paginator')
      .bind('click.paginator', function () {
        var c = $(this).parent('li:first').attr('class');
        var s = c.match(/scroll-([a-z0-9]+)/);
        if (s) {
          _navigate(table, state, s[1]);
        }
        return false;
      });
  };

  /* Searchfield
   * ---------------------------------------------------------------- */

  const searchfield = function (table) {
    $(o.searchfield).each(function () {
      var timeout = null,
        searchfield = $(this);

      searchfield.off('keyup.search').on('keyup.search', function (_e) {
        var state = o.paginator;
        state['filter'] = $(this).val().trim();
        state['page'] = 1;
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
        timeout = setTimeout(function () {
          load(table, state);
        }, o.filterDelay);
      });
    });
  };

  /* Sorting
   * ---------------------------------------------------------------- */

  const sorting = function (table) {
    var thead = table.find(o.thead);
    thead.find('th:not(.categories)').each(function (i) {
      if (i in o.columns && 'sort' in o.columns[i]) {
        var id = o.columns[i]['sort'];
        var th = $(this);
        th.on('click.sorting', function () {
          thead.find('th[class*="sort-"]').removeClass('sort-asc sort-desc');

          if (o.paginator.order.split(',')[0] != id) {
            o.paginator.order = id;
            th.addClass('sort-asc');
          } else {
            o.paginator.order = '-' + id;
            th.addClass('sort-desc');
          }

          Cookies.set(
            'table-sort-order-' + location.pathname,
            o.paginator.order,
          );

          load(table, o.paginator);

          return false;
        });
      }
    });
  };

  function handleKeyboardShortcut(event) {
    if (event.code === 'KeyK' && (event.metaKey || event.ctrlKey)) {
      event.preventDefault();
      event.stopPropagation();

      $(o.searchfield).trigger('focus').trigger('select');
    }
  }

  /* Setup
   * ---------------------------------------------------------------- */

  this.each(function (_options) {
    const table = $(this);
    const sortorder = Cookies.get('table-sort-order-' + location.pathname);
    const pageno = Cookies.get('table-page');
    const category = Cookies.get('table-category-' + location.pathname);

    if (sortorder != null) {
      o.paginator.order = sortorder;
    }

    if (pageno != null) {
      o.paginator.page = pageno;
    }

    if (category) {
      o.paginator.category = category;
    }

    paginator(table, o.paginator);
    searchfield(table);
    sorting(table);
    load(table, o.paginator);

    window.addEventListener('keydown', handleKeyboardShortcut);
  });

  return this;
};

$.fn.xiTable.defaults = {
  queryUrl: location.href,
  columns: ['_id'],
  searchfield: '#filter',
  tbody: 'tbody',
  thead: 'thead',
  maxPages: 7,
  itemCounts: [5, 10, 15, 25, 50, 100],
  filterDelay: 500,
  categoryTitleColumn: 'title',
  debug: false,
};
